import { abyssColors } from '@/theme/colors';

export const auditTabStyles = {
  width: 'fit-content',
  minHeight: 'fit-content',

  '& .MuiTabs-flexContainer': {
    width: 'fit-content',
    gap: '2rem',
  },
  '& .MuiTab-root': {
    width: 'auto',
    padding: '0.8rem 0.6rem',
    fontSize: '1.2rem',
    fontStyle: 'normal',
    letterSpacing: '0.014rem',
    fontWeight: 400,
    minWidth: 'fit-content',
    minHeight: 'fit-content',
    textTransform: 'none',
    lineHeight: '1.6rem',
    color: `${abyssColors.primary[400]} !important`,
  },
  '& .MuiTab-root.Mui-selected': {
    color: `${abyssColors.primary[500]} !important`,
    fontWeight: 700,
  },
  '& .MuiTab-textColorPrimary': {
    color: abyssColors.primary[400],
  },
  '& .MuiTabs-indicator': {
    backgroundColor: abyssColors.primary[500],
    height: '0.3rem',
    borderRadius: '0.2rem',
    zIndex: 2,
  },
};
